import apiProxy from './api-proxy-inst';

class OrderApi {
  userInstOrderList(args) {
    return apiProxy.request('/cur_user_erpapp_inst_order/list', args).then(data => {
      return data;
    });
  }

  userInstOrderCount(args) {
    return apiProxy.request('/cur_user_erpapp_inst_order/count', args).then(data => {
      return data;
    });
  }

  cancelOrder(args) {
    return apiProxy.request('/cur_user_erpapp_order/cancel', args).then(data => {
      return data;
    });
  }

  productList(args) {
    return apiProxy.requestPublic('/erpapp_on_shelf_product/list', args).then(data => {
      return data;
    });
  }

  calculate(args) {
    return apiProxy.request('/erpapp_purchase_order_payable_amount/calculate', args).then(data => {
      return data;
    });
  }

  renewal(args) {
    return apiProxy.request('/erpapp_renewal_upgrade_order_payable_amount/calculate', args).then(data => {
      return data;
    });
  }

  purchaseCreate(args) {
    return apiProxy.request('/erpapp_purchase_order/create', args).then(data => {
      return data;
    });
  }

  renewalCreate(args) {
    return apiProxy.request('/erpapp_renewal_upgrade_order/create', args).then(data => {
      return data;
    });
  }

  createSubSession(args) {
    // return apiProxy.request('/erpapp_inst/createSession', args).then(data => {
    //   return data;
    // });
    return apiProxy.request('/stripe/createSubscription', args).then(data => {
      return data;
    });
  }

  applyTrialOrder(args) {
    return apiProxy.request('/cur_user_erpapp_order/trial', args).then(data => {
      return data;
    });
  }

  createSession(args) {
    return apiProxy.request('/stripe/createSession', args).then(data => {
      return data;
    });
  }

  createTrialSession(args) {
    return apiProxy.request('/stripe/createTrialSession', args).then(data => {
      return data;
    });
  }

  getStripeKey(args) {
    return apiProxy.request('/stripe/getKey', args).then(data => {
      return data;
    });
  }

  subscriptCreate(args) {
    return apiProxy.request('/subscript_order/create', args).then(data => {
      return data;
    });
  }
}

export default new OrderApi();